import { useQuery } from "react-query";

import { getClinicianBasicInfoAsync } from "api/clinician";
import { GET_CLINICIAN_BASIC_INFO, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";

/**
 * @description `useGetClinicianBasicInfo` is a hook that fetches a clinician's basic information using a GET request to
 * `/v2/clinician/[userId]/basic` endpoint.
 * @param {string} clinicianId - The clinician ID
 * @param {Object} options - The React Query options
 * @returns {Promise} The clinician basic information
 */
export const useGetClinicianBasicInfo = (clinicianId, options = {}) => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_CLINICIAN_BASIC_INFO, clinicianId],
    () => getClinicianBasicInfoAsync(clinicianId),
    {
      enabled: Boolean(clinicianId),
      refetchOnWindowFocus: false,
      staleTime: STALE_TIME_5_MINUTES,
      ...options,
    }
  );

  return {
    clinicianBasicInfo: data?.data || null,
    clinicianBasicInfoLoading: isLoading,
    ...rest,
  };
};
